<template>
  <div class="form-item-errors">
    <ul class="form-item-errors__list">
      <li v-for="(errorMessage, index) in errorMessages" :key="`form-item-errors--${props.element.metadata?.key}-${index}`" class="form-item-errors__item">
        {{ errorMessage }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { type WebformElementOptionsBaseFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

const props = defineProps<{
  element: WebformElementOptionsBaseFragment,
  formErrors: WebformSubmissionValidationErrorFragment[]
}>()

const errorMessages = computed(() => {
  for (let index = 0; index < props.formErrors.length; index++) {
    if (props.formErrors[index].element === props.element.metadata?.key) {
      return props.formErrors[index].messages
    }
  }
})

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.form-item-errors {
  color: var(--color-error);
  @include tools.typo-small;
}

</style>
